import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Message } from '../../../conversation/components/message';
import { getAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';
export const NoteAdded = ({ entry }) => {
    const authorName = getAuthorName(entry);
    const authorLink = _jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName }));
    const text = _jsxs(_Fragment, { children: ["Internal note is added by ", authorLink] });
    const messageAuthor = Object.assign(Object.assign({}, entry.author), { avatar_url: entry.author_avatar_url, roles: [] });
    return (_jsx(LogEntry, Object.assign({ entry: entry, text: text }, { children: _jsx(Message, { className: styles.message, internal: true, author: messageAuthor, markup: entry.message, date: "" }) })));
};
